"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M16.5 13h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1Zm0 3h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1Zm0 3h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1Zm-5-2h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1Zm12-13H8.908A1.496 1.496 0 0 0 8 3.092V.5a.5.5 0 0 0-1 0V3H4.5c-.651 0-1.201.419-1.408 1H.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h2.592c.207.581.757 1 1.408 1h3c.651 0 1.201-.419 1.408-1H23.5a.5.5 0 0 0 .5-.5v-18a.5.5 0 0 0-.5-.5ZM3.158 19.066a1.513 1.513 0 0 0-.158.67V22H1V5h2v2.264c0 .232.055.464.158.671l.789 1.578A.508.508 0 0 1 4 9.736v7.528a.516.516 0 0 1-.053.224l-.789 1.578ZM8 22.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2.764c0-.077.019-.154.053-.224l.789-1.578c.103-.207.158-.439.158-.67V9.736c0-.232-.055-.464-.158-.671l-.789-1.578A.508.508 0 0 1 4 7.264V4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2.764a.516.516 0 0 1-.053.224l-.789 1.578a1.513 1.513 0 0 0-.158.67v7.528c0 .232.055.464.158.671l.789 1.578a.508.508 0 0 1 .053.223V22.5Zm15-.5H9v-2.264c0-.232-.055-.464-.158-.671l-.789-1.578A.508.508 0 0 1 8 17.264V9.736c0-.077.019-.154.053-.223l.789-1.579c.103-.207.158-.439.158-.67V5h14v17ZM11.5 11h9a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5Zm.5-3h8v2h-8V8Zm-.5 6h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1Zm0 6h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1Zm9-4h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1Zm0-3h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1Zm0 6h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1Z",
    clipRule: "evenodd"
  })]
});